export const MAIN_CATEGORY = 'mainCategory' as const;
export const ALL_CATEGORIES = 'allCategories' as const;
